import { useContext } from 'react';
import { AuthenticationContext } from '../authentication/AuthenticationContext';
import axios from 'axios';

export const useApi = () => {
  const { accessToken } = useContext(AuthenticationContext);

  const instance = axios.create({
    baseURL: 'https://api.as2alni.com',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return instance;
};
